export default "__VITE_ASSET__CL2IjJ4b__"